// extracted by mini-css-extract-plugin
export default {"screen_content_layout":"screensLayout_screen_content_layout__s9Ni+","screen_content_layout_home":"screensLayout_screen_content_layout_home__-yIpI"};